import React from "react";
import "./about.css";
import ImageGallery from "react-image-gallery";
import { ImLocation } from "react-icons/im";
import { FaWalking } from "react-icons/fa";
import { AiFillCar } from "react-icons/ai";
const images = [
  {
    original:
      "https://images.unsplash.com/photo-1503174971373-b1f69850bded?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1513&q=80",
    thumbnail:
      "https://images.unsplash.com/photo-1503174971373-b1f69850bded?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1513&q=80",
  },
  {
    original:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    thumbnail:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
  },
  {
    original:
      "https://images.unsplash.com/photo-1611094016919-36b65678f3d6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    thumbnail:
      "https://images.unsplash.com/photo-1611094016919-36b65678f3d6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
  },
];

function About() {
  return (
    <div className="container-fluid about-page-cover">
      <div className="about-page-cover container mt-5">
        <section>
          <h2 className=" fs-2 m-5">О проекте</h2>
          <br />

          <div className="row">
            <div className="col-sm-8">
              <p>
                Mirabad Avenue — уникальный проект. Это первая резиденция
                премиум-класса в Узбекистане, являющаяся совместным проектом с
                британским архитектурным бюро Chapman Taylor.
              </p>
              <br />
              <p>
                Уникальность проекта не только в новаторском подходе к
                проектированию, но и в новом формате использования пространства.
                Например, для подавления уличного шума, двор резиденции будет
                расположен на платформе, возвышающейся над землёй на 4 метра.
                Эта же платформа послужит площадью для подземного паркинга
                жителей резиденции. И подобных нововведений в резиденции масса.
              </p>
              <br />
              <p>
                Именно в Mirabad Avenue расположится первая в стране
                шопинг-авеню по всей территории комплекса. Бутики, рестораны,
                салоны и шоурумы создадут новый облик столицы, выводя одну из
                оживлённых центральных улиц на один уровень с Елисейскими
                полями, Арбатом и Пятой Авеню.
              </p>
              <br />
            </div>
            <div className="col-sm-4">
              <ul>
                <li className="about-list">
                  Двор на платформе Дворы возвышаются на 4 метра, под каждым — 2
                  уровня паркинга.
                </li>
                <li className="about-list">
                  Двор-парк Подобранные растения создадут особую эко-систему в
                  каждом дворе.
                </li>
                <li className="about-list">
                  Шопинг-авеню Длина по периметру резиденции превысит 2 км.
                </li>
              </ul>
            </div>
            <br />
            <br />
            <hr className="divider" />
            <div className="container mt-4">
              <div className=" animate-animated animate__bounceInLeft container">
                <ImageGallery items={images} />
              </div>
            </div>
            <br />
            <h2 className="text-center mt-5">Our other projects</h2>
            <br />
            <div className="row mt-3">
              <div className="col-sm-8">
                <ImageGallery items={images} />
              </div>
              <div className="col-sm-4 px-5">
                <h2 className="text-center">ПРИВАТНЫЕ ТЕРРАСЫ</h2>
                <br />
                <p>
                  Первое и уникальное в своём роде предложение на рынке
                  недвижимости. Приобретая апартаменты на 9 этаже, покупатель
                  становится владельцем собственной приватной террасы.
                  <br />
                  <br />
                  Ещё одно новшество резиденции — башни с пентхаусами с
                  персональным доступом через лифт.
                </p>
              </div>
            </div>

            <h2 className="text-center mt-5">ЛОББИ И КОНСЬЕРЖ-СЕРВИС</h2>
            <br />
            <div className="row mt-3">
              <div className="col-sm-4">
                <h2 className="text-center">ЛОББИ И КОНСЬЕРЖ-СЕРВИС</h2>
                <br />
                <p>
                  В каждом блоке обустроены комфортабельные лобби площадью 150
                  м² сотдельной зоной для встречи гостей и комфортабельного
                  общения вне апартаментов. подачи авто и встречи гостей.
                  <br />
                  <br />
                  Помимо охраны, гостей и жителей в лобби будут встречать
                  консьержи, которым можно поручить решение любого бытового
                  вопроса — от заказа доставки и химчистки до
                </p>
              </div>
              <div className="col-sm-8 px-5">
                <ImageGallery items={images} />
              </div>
            </div>
            <div className="container"></div>
            <br />
            <br />
            <br />
            <hr className="divider" />
            <br />
            <br />
            <br />
            <div className="row">
              <div className="col-sm-4">
                <h2 className="text-center">ЛОКАЦИЯ</h2>
                <br />
                <br />
                <p>
                  Локация, выбранная для строительства Mirabad Avenue, идеально
                  подходит для нового центра шопинга и жизнедеятельности.
                  Резиденция расположена в престижном районе столицы, а по
                  соседству с ней имеется всё необходимое для жизнеобеспечения
                  жителей и гостей — фитнес-клубы, частные детские сады и школы,
                  супермаркеты, парки и многое другое.
                </p>
              </div>
              <div className="col-sm-8">
                <img
                  src="https://mirabad.uz/upload/kelnik.adminpage/b9a/b9afc6e43dc302a195c629a4ada6620a.svg"
                  alt=""
                  className="image-fluid"
                />
              </div>
            </div>
            <div className="container"></div>
            <br />
            <br />
            <br />
            <br />

            <div className="row mt-3">
              <div className="col-sm-4">
                <h2 className="text-center">ЛОББИ И КОНСЬЕРЖ-СЕРВИС</h2>
                <br />
                <p>
                  Внутренние дворы резиденции — закрытые от посторонних глаз.
                  Они приватны, лишены автомобилей и находятся на буферной
                  подушке в 4м. Зонирование продумано, комфортный отдых
                  предусмотрен для каждого жителя, вне зависимости от возраста.
                  Двухуровневый паркинг для жителей резиденции будет находиться
                  под двором.
                </p>
              </div>
              <div className="col-sm-8 px-5">
                <ImageGallery items={images} />
              </div>
            </div>
            <div className="container"></div>
            <br />
            <br />
            <br />
            <br />
            <div className="row mt-3">
              <div className="col-sm-8 px-5">
                <ImageGallery items={images} />
              </div>
              <div className="col-sm-4">
                <h2 className="text-center">ШОПИНГ-АВЕНЮ</h2>
                <br />
                <p>
                  Уникальное в своём роде решение продумано не только с
                  коммерческой точки зрения в соответствии с мировыми
                  требованиями и опытом других стран, но также предусматривает
                  максимально комфортное нахождение на шопинг-авеню жителей и
                  гостей резиденции. Общая длина шопинг-авеню по всему периметру
                  превысит 2 км.
                </p>
              </div>
            </div>
            <div className="container"></div>
            <br />
            <br />
            <hr className="divider" />
            <br />
            <br />
            <div className="container">
              <h2 className="text-center">Расположение</h2>
              <div className="row">
                <div className="col-sm-4">
                  <div className="row">
                    <div className="col-sm-4  d-flex justify-content-center align-items-center ">
                      <h1
                        style={{
                          color: "#EF5B0C",
                          fontSize: "70px",
                        }}
                      >
                        <ImLocation />
                      </h1>
                    </div>
                    <div className="col-sm-8 d-flex justify-content-center align-items-center ">
                      Узбекистан, г. Ташкент, ул. Мирабад, 60
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="row">
                    <div className="col-sm-4  d-flex justify-content-center align-items-center ">
                      <h1
                        style={{
                          color: "#EF5B0C",
                          fontSize: "70px",
                        }}
                      >
                        <AiFillCar />
                      </h1>
                    </div>
                    <div className="col-sm-8 d-flex justify-content-center align-items-center ">
                      8 минут до аэропорта
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="row">
                    <div className="col-sm-4  d-flex justify-content-center align-items-center ">
                      <h1
                        style={{
                          color: "#EF5B0C",
                          fontSize: "70px",
                        }}
                      >
                        <FaWalking />
                      </h1>
                    </div>
                    <div className="col-sm-8 d-flex justify-content-center align-items-center ">
                      3 минуты до Мирабадского рынка
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
            </div>
            <div className="container"></div>
            <br />
            <br />
            <hr className="divider" />

            <br />
            <br />
            <div className="container"></div>
            <div
              style={{
                height: "450px",
              }}
              className="container"
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11986.423311782935!2d69.27484654708255!3d41.31743787677365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8b2a6565712d%3A0x790feb8933429946!2sNational%20Library%20of%20Uzbekistan!5e0!3m2!1sen!2s!4v1659008300250!5m2!1sen!2s"
                className="w-100 h-100"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <br />
            <br />
            <div className="container"></div>
            <hr className="divider" />
            <div className="container"></div>
            <br />
            <br />
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
